<template>
  <FocusTrap>
    <div class="card">

    <div class="card-header header-elements-inline" >
      <h5 class="card-title">Article Creation</h5>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <form action="#">

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Name:</label>
          <div class="col-md-10">
            <input  id="txtname" type="text" class="form-control" placeholder="Enter Article Name here..." maxlength="100" autofocus v-if="article" v-model="article.name" >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Print Name:</label>
          <div class="col-md-10">
            <input type="text" class="form-control" placeholder="Enter your print name here..." maxlength="100" v-if="article" v-model="article.p_name">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Nature:</label>
          <div class="col-md-10">
            <select class="form-control" v-if="article" v-model="article.nature">
              <!--<option value="11">Yarn</option>-->
              <option value="12">Fabric</option>
              <option value="13">Made-Up</option>
            </select>
          </div>
        </div>



        <div class="form-group row">
          <label class="col-md-2 col-form-label">HSN:</label>
          <div class="col-md-4">
            <input type="text" class="form-control" placeholder="Enter HSN here..." maxlength="8" v-if="article" v-model="article.hsn">
          </div>

          <label class="col-md-2 col-form-label">GST %:</label>
          <div class="col-md-1">
            <input type="number" class="form-control" placeholder="Enter GST Rate..." min="0" max="42" v-if="article" v-model="article.gst_rate">
          </div>
          <label class="col-md-2 col-form-label">ITC %:</label>
          <div class="col-md-1">
            <input type="number" class="form-control" placeholder="Enter ITC here..." min="0" max="100" v-if="article" v-model="article.itc_rate">
          </div>
        </div>

        <div class="form-group row">

          <label class="col-md-2 col-form-label">Unit</label>
          <div class="col-md-2">
            <select class="form-control" v-if="article" v-model="article.main_unit.code">
              <option value="1">Nos</option>
              <option value="2">Kgs</option>
              <option value="3">Mts</option>
              <option value="5">Doz</option>
              <option value="1001">Bundle</option>
              <option value="1002">Knots</option>
            </select>
          </div>

          <label class="col-md-2 col-form-label">Conv Fact:</label>
          <div class="col-md-2">
            <input type="number" class="form-control" placeholder="Conv Fact" step="1" min="1" max="300" v-if="article" v-model="article.conv_fact">
          </div>

          <label class="col-md-2 col-form-label">Sub Unit:</label>
          <div class="col-md-2">
            <select class="form-control" v-if="article" v-model="article.sub_unit.code">
              <option value="1">Nos</option>
              <option value="2">Kgs</option>
              <option value="3">Mts</option>
              <option value="5">Doz</option>
              <option value="1001">Bundle</option>
              <option value="1002">Knots</option>
            </select>
          </div>

        </div>

      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
  </FocusTrap>
</template>

<script>
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'ArticleForm',
    data () {
      return {
        article: JSON.parse('{"id":"","code":0,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0}')
      }
    },
    props: {
      myarticle: {
        type: Object,
        default: () => JSON.parse('{"id":"","code":0,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0}')
      }
    },
    beforeMount () {
      this.article = this.myarticle; // save props data to itself's data and deal with tms
    },
    component: {

    },
    created () {
      this.$data.article = JSON.parse('{"id":"","code":0,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0}')
    },
    mounted () {
      $('#txtname').focus();
      // $('.form-control-select2').select2()
    },
    methods: {
      closeWindow(){
        this.$parent.$parent.closeModal();
      },
      clear(){
        this.$data.article = JSON.parse('{"id":"","code":0,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0}')
      },
      saveDocument(){
        let self = this;

        self.$data.article.gst_rate = parseFloat(self.$data.article.gst_rate);
        self.$data.article.itc_rate = parseFloat(self.$data.article.itc_rate);

        self.$data.article.nature = parseInt(self.$data.article.nature);
        self.$data.article.main_unit.code = parseInt(self.$data.article.main_unit.code);
        self.$data.article.conv_fact = parseInt(self.$data.article.conv_fact);
        self.$data.article.sub_unit.code = parseInt(self.$data.article.sub_unit.code);


        if(self.$data.article.name.trim().length < 1){
          alert("Invalid Name");
          return
        }else if(self.$data.article.main_unit.code < 1){
          alert("Invalid Unit Code");
          return
        }else if(self.$data.article.sub_unit.code < 1){
          alert("Invalid Sub Unit Code");
          return
        }else if(self.$data.article.conv_fact < 1){
          alert("Invalid Conversion Factor");
          return
        }

        const requestOptions = {
          method:  (self.$data.article.code == 0 ? 'POST' : 'PUT'),
          mode:"cors",
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.article)
        };

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/article/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            swal ( { title: "Success!" ,  text: data.message, icon:  "success"} );
            self.group = JSON.parse('{"id":"","code":0,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0}');
            self.$parent.$parent.loadData();
            self.closeWindow();
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });
      }
    }
  }
</script>

<style scoped>

</style>
